import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwaitModules, LL_H_C, LL_V_L, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import './AdvisorMiniPanel_EventFeed.scss';
import { PanelKey_EventFeed, PanelKey_Home } from '../../../_shared.js';
import { Advisor_ErrorBoundary } from '../../components/Advisor_ErrorBoundary/Advisor_ErrorBoundary.js';
import { ICONS } from '@app/styles';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { ModuleFE_RuntimeEncounterFeed } from '../../../modules/runtime/index.js';
import { Component_EncounterFeed } from '../../components/encounter-feed/Component_EncounterFeed/Component_EncounterFeed.js';
export class AdvisorMiniPanel_EventFeed extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_EventFeed,
        panelType: 'secondary',
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state); // call super derive to resolve provider type & readonly mode into the state
        return state;
    }
    //######################### Logic #########################
    closePanel = () => {
        ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
    };
    //######################### Render #########################
    render() {
        const className = this.getPanelClass();
        return _jsx(TS_ErrorBoundary, { renderer: (e) => _jsx(Advisor_ErrorBoundary, { error: e, panelKey: this.props.panelKey, dir: 'vertical', onClick: () => {
                    this.reDeriveState({ error: undefined });
                } }), error: this.state.error, children: _jsxs(LL_V_L, { className: className, innerRef: this.panelRef, onClick: this._onPanelClick, "data-panel-key": this.props.panelKey, children: [this.render_Header(), _jsx(AwaitModules, { modules: [ModuleFE_RuntimeEncounterFeed], Component: () => this.render_Feed() })] }) });
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => undefined;
    renderHeader_Tail = undefined;
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'header', children: [_jsxs(LL_V_L, { className: 'header-main', children: [_jsx("div", { className: 'title', children: "Events" }), _jsx("div", { className: 'sub-title', children: "Your complete timeline and latest notifications" })] }), _jsx(ICONS.advisor_avn_close.component, { onClick: this.closePanel })] });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    renderContent = () => undefined;
    render_Feed = () => {
        const feedItems = ModuleFE_RuntimeEncounterFeed.getFeedItems();
        return _jsxs(LL_V_L, { className: 'feed-wrapper', children: [!!feedItems.today.length && _jsxs(_Fragment, { children: [_jsx("div", { className: 'feed-wrapper__title', children: _jsx("span", { children: "Today" }) }), _jsx(Component_EncounterFeed, { feedItems: feedItems.today, renderContext: 'event-log' })] }), !!feedItems.older.length && _jsxs(_Fragment, { children: [_jsx("div", { className: 'feed-wrapper__title', children: _jsx("span", { children: "Older" }) }), _jsx(Component_EncounterFeed, { feedItems: feedItems.older, renderContext: 'event-log' })] })] });
    };
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_EventFeed.js.map